import { z } from 'zod';
import { codeSchema } from '../code.js';
export const TEMPLATE_KINDS = ['RESPONSE', 'INFORMATION_REQUEST', 'NOTIFICATION', 'TRANSFER', 'CLOSURE', 'EMAIL'];
/** Las únicas que se eligen al responder un caso, y por eso las únicas que llevan área y tipo de caso; las demás las usan los pasos del flujo por su código. */
export const SCOPED_TEMPLATE_KIND = 'RESPONSE';
/**
 * PUT /communications/templates. Una plantilla de respuesta puede ser de un área (y de sus subáreas, salvo
 * `includeSubareas: false`) y de un tipo de caso; sin ellos sirve para toda la entidad y todos los tipos.
 */
export const templateInputSchema = z.object({
    code: codeSchema(60),
    kind: z.enum(TEMPLATE_KINDS),
    name: z.string().trim().min(1).max(200),
    subject: z.string().optional(),
    body: z.string().min(1),
    active: z.boolean().optional(),
    caseTypeId: z.string().uuid().nullable().optional(),
    organizationalUnitId: z.string().uuid().nullable().optional(),
    includeSubareas: z.boolean().optional(),
}).refine((t) => t.kind === SCOPED_TEMPLATE_KIND || (!t.caseTypeId && !t.organizationalUnitId), { message: 'Solo las plantillas de respuesta llevan área o tipo de caso', path: ['organizationalUnitId'] });
//# sourceMappingURL=templates.js.map